export const CATEGORIE_FORFAIT_AUDIT = 'Forfait Audit';

export const LISTE_CATEGORIES_HONORAIRE = [
  CATEGORIE_FORFAIT_AUDIT,
  'honoraire'
]

export const COULEUR_PANNEAU_DEFAUT = '#3598DC';
export const COULEUR_PANNEAU_SOUS_CONTRAT = '#4d4d4d';

export const LISTE_AZIMUT = [
  '0°',
  '30°',
  '60°',
  '90°',
  '120°',
  '150°',
  '180°',
  '210°',
  '240°',
  '270°',
  '300°',
  '330°',
];
